module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Pj3Tkk/images/cover.jpg?1685327561680",
      "alt": "This image is the cover for the book Ed & Marchant, Frankie's Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ed & Marchant, Frankie's Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("A Novella in Frankie's Series")])])]), _c('p', [_vm._v("Ed Winters despises his job and hates everyone he works with—especially out and proud, happily in love Frankie Mason. He spends his days wishing he could dance, rather than work.")]), _vm._v(" "), _c('p', [_vm._v("Late to go shopping one day, Ed ends up soaked in Marchant Belarus’s spilled Coke. Ed’s humiliation increases when Marchant, the owner of a BDSM club, realizes Ed is a sub, albeit a very closeted one. Marchant’s attempts to draw Ed out of his shell release years of pent-up anger and hurt over the abuse Ed’s mother and grandmother heaped on him.")]), _vm._v(" "), _c('p', [_vm._v("Marchant is patient, but nothing he does seems to help until he discovers Ed’s secret love of dancing—a forbidden passion that might be the key to unlocking the confident, secure man Ed could be.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sue Brown\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0